import TopSearch from "@/components/TopSearch";
import i18n from 'i18next';
import React from "react";
import { useTranslation } from 'react-i18next';
import "./baseDict.less";
import { DataBox } from "./DataBox";
export default function BaseDict() {
    const { t } = useTranslation();
    return (
        <>
            <TopSearch title= {i18n.t(`base.view.index.数据字典`)} />
            <DataBox />
        </>
    )
}